<template>
  <div>
    <div v-if="!isNewCardVisible" style="max-width:600px;">
      <div
        :key="index"
        v-for="(option, index) in paymentMethods"
        class="mb-2 bg-white rounded p-3 font-weight-bold card-item"
        style="font-size: 13px"
      >
        <div
          class="d-flex justify-content-between align-items-center w-100 card-item-padding"
        >
          <div
            class="d-flex flex-wrap justify-content-between align-items-center card-item-gap"
          >
            <div class="d-flex flex-wrap align-items-center card-item-gap">
              <div>
                <img
                  :src="getImgUrl(option.cardType)"
                  width="30"
                  :title="option.cardType"
                />
              </div>
              <div>*** {{ option.lastFour }}</div>
              <div>
                  {{ option.expDate?.slice(0, 2) }}/{{option.expDate?.slice(2)}}
              </div>
            </div>
            <div class="card-comment">
              {{
                option.comments
                  ? `(${option.comments})`
                  : ""
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-link
      class="ml-4 mt-2"
      style="font-size: 15px"
      @click="isNewCardVisible = true"
    >
      <b>Add new card</b>
    </b-link>
    <div
      class="new-card"
      style="max-width:600px;"
      v-if="isNewCardVisible || activeNewCard"
    >
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.cardNumber.length == 0 ? null : false"
            :invalid-feedback="formErrors.cardNumber.join(', ')"
          >
            <template v-slot:label>
              Card number <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.cardNumber"
              trim
              :state="formErrors.cardNumber.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.nameOnCard.length == 0 ? null : false"
            :invalid-feedback="formErrors.nameOnCard.join(', ')"
          >
            <template v-slot:label>
              Name on card <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.nameOnCard"
              trim
              :state="formErrors.nameOnCard.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label="Expiration date">
            <template v-slot:label>
              Expiration date <span class="text-danger">*</span>
            </template>
            <div class="d-flex">
              <v-select
                style="width: 80px"
                v-model="form.expMonth"
                :options="months"
                :clearable="false"
              ></v-select>
              <v-select
                style="width: 100px"
                class="ml-2"
                v-model="form.expYear"
                :options="years"
                :clearable="false"
              ></v-select>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            :state="formErrors.street1.length == 0 ? null : false"
            :invalid-feedback="formErrors.street1.join(', ')"
          >
            <template v-slot:label>
              Billing Address: <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.street1"
              trim
              :state="formErrors.street1.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group
            :state="formErrors.city.length == 0 ? null : false"
            :invalid-feedback="formErrors.city.join(', ')"
          >
            <template v-slot:label>
              City <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.city"
              trim
              :state="formErrors.city.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label="State"
            :state="formErrors.stateId.length == 0 ? null : false"
            :invalid-feedback="formErrors.stateId.join(', ')"
          >
            <template v-slot:label>
              State <span class="text-danger">*</span>
            </template>
            <v-select v-model="form.stateId" :options="states"></v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group
            :state="formErrors.zipCode.length == 0 ? null : false"
            :invalid-feedback="formErrors.zipCode.join(', ')"
          >
            <template v-slot:label>
              Zip Code <span class="text-danger">*</span>
            </template>
            <b-form-input
              v-model="form.zipCode"
              v-facade="'#####'"
              trim
              :state="formErrors.zipCode.length == 0 ? null : false"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" cols="12">
          <b-form-group>
            <template v-slot:label>
              Comments
            </template>
            <b-form-input
              v-model="form.comments"
              trim
              placeholder="i.e ”Mom’s Card”"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <div class="d-flex w-100 px-3 mb-2">
          <b-form-checkbox v-model="form.generalConditions">
            <div class="d-flex flex-col"></div>
            <span style="font-size: 16px;">
              By checking this box, I am authorizing
              {{ organizationName ?? "" }} to use any payment methods on file
              for patient responsibility or estimated amount at the time of
              service, any balances, late cancelation and no-show fees without
              additional authorization.
            </span>
            <div
              class="text-danger mt-2"
              style="font-size: 15px;"
              v-if="formErrors.generalConditions?.length > 0"
            >
              <i class="fa fa-exclamation-circle"></i>
              {{ formErrors.generalConditions[0] }}
            </div>
          </b-form-checkbox>
        </div>
      </b-row>
      <b-row class="justify-content-end mr-2">
        <b-button
          class="text-white mr-2"
          variant="secondary"
          @click="clearForm()"
          :disabled="loading"
        >
          Cancel
        </b-button>
        <b-button class="text-white" variant="success" @click="submitCard()">
          <b-spinner
            v-if="loading"
            style="width: 1rem; height: 1rem"
            class="text-white"
            label="Spinning"
          ></b-spinner>
          <span v-else> Save </span>
        </b-button>
      </b-row>
    </div>
  </div>
</template>

<script>
import paymentMethodsServer from "../../server/paymentMethod";
import { validateRequired, validateZipcode } from "../../helpers/validation";
import payaServer from "../../server/paya";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "PatientPaymentMethods",
  props: ["patientId", "value", "hideSelect", "activeNewCard"],
  data() {
    return {
      loading: false,
      paymentMethods: [],
      isNewCardVisible: false,
      form: {
        nameOnCard: "",
        cardNumber: "",
        expirationDate: "",
        expMonth: "01",
        expYear: "",
        zipCode: "",
        stateId: "",
        city: "",
        street1: "",
        saveCard: true,
        generalConditions: false,
        comments: ""
      },
      formErrors: {
        nameOnCard: [],
        cardNumber: [],
        street1: [],
        city: [],
        zipCode: [],
        stateId: [],
        generalConditions: []
      },
      months: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
      ],
      years: []
    };
  },
  async mounted() {
    this.getAllPaymentMethods();
    this.generateNext10Years();
    this.form.expYear = this.years[0];
  },
  methods: {
    async getAllPaymentMethods() {
      await paymentMethodsServer.query(this.patientId).then(response => {
        this.paymentMethods = response.data;
      });
      this.isNewCardVisible = false;
      if (this.paymentMethods.length > 0) {
        this.selected = this.paymentMethods[0].ccInfoKey;
      }
    },
    getImgUrl(pic) {
      let fileName = "";
      try {
        fileName = require("../../assets/cards/" +
          pic.toLowerCase().trim() +
          ".png");
      } catch (e) {
        fileName = require("../../assets/cards/default_card.png");
      }
      return fileName;
    },
    generateNext10Years() {
      var currentYear = moment().year();

      for (var i = 0; i < 10; i++) {
        this.years.push((currentYear + i).toString());
      }
    },
    validateFormSubmit() {
      let withoutErrors = true;

      this.formErrors.nameOnCard = [];
      if (!validateRequired(this.form.nameOnCard)) {
        this.formErrors.nameOnCard.push("This field is required.");
        withoutErrors = false;
      }
      this.formErrors.cardNumber = [];
      if (!validateRequired(this.form.cardNumber)) {
        this.formErrors.cardNumber.push("This field is required.");
        withoutErrors = false;
      } else if (
        this.form.cardNumber.replace(" ", "").length != 16 &&
        this.form.cardNumber.replace(" ", "").length != 15
      ) {
        this.formErrors.cardNumber.push("Card number is not correct.");
        withoutErrors = false;
      }

      this.formErrors.street1 = [];
      if (!validateRequired(this.form.street1)) {
        this.formErrors.street1.push("This field is required.");
        withoutErrors = false;
      }

      this.formErrors.city = [];
      if (!validateRequired(this.form.city)) {
        this.formErrors.city.push("This field is required.");
        withoutErrors = false;
      }

      this.formErrors.zipCode = [];
      if (!validateRequired(this.form.zipCode)) {
        this.formErrors.zipCode.push("This field is required.");
        withoutErrors = false;
      }
      if (this.form.zipCode && !validateZipcode(this.form.zipCode)) {
        this.formErrors.zipCode.push(
          "This field must have a valid zipcode format."
        );
        withoutErrors = false;
      }

      this.formErrors.stateId = [];
      if (!validateRequired(this.form.stateId)) {
        this.formErrors.stateId.push("This field is required.");
        withoutErrors = false;
      }

      this.formErrors.generalConditions = [];
      if (!this.form.generalConditions) {
        this.formErrors.generalConditions.push(
          "To continue please accept general conditions"
        );
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitCard() {
      const result = this.validateFormSubmit();
      if (result) {
        this.form.expirationDate =
          this.form.expMonth + this.form.expYear.slice(-2);
        this.loading = true;
        await payaServer
          .addPaymentMethod(this.patientId, {
            ...this.form,
            stateId: this.form.stateId.value,
            comments: this.form.comments
          })
          .then(async resp => {
            if (resp.data.isOk) {
              this.isNewCardVisible = false;
              this.loading = false;
              this.clearForm();
              await this.getAllPaymentMethods();
            } else {
              this.$dialog.alert("Error: " + resp.data.errorMessage);
              this.loading = false;
            }
          });
      }
    },
    clearForm() {
      this.form = {
        nameOnCard: "",
        cardNumber: "",
        expirationDate: "",
        expMonth: "",
        expYear: "",
        zipCode: "",
        stateId: "",
        city: "",
        street1: "",
        comments: ""
      };

      this.formErrors = {
        nameOnCard: [],
        cardNumber: [],
        street1: [],
        city: [],
        zipCode: [],
        stateId: []
      };

      this.form.expMonth = this.months[moment().month()];

      this.form.expYear = moment()
        .year()
        .toString();
      this.isNewCardVisible = false;
    }
  },
  computed: {
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.abbreviation
        }))
    }),
    ...mapState("session", {
      organizationName: state => state.systemSettings.organizationName
    })
  },
  watch: {
    "form.generalConditions": {
      handler: function(val) {
        val === true && (this.formErrors.generalConditions = []);
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}

.custom-control-label {
  width: 100%;
}

.new-card {
  background-color: #f1f1f1;
  padding: 15px;
  border-radius: 15px;
  margin-top: 10px;
  width: 50%;
}

.card-item {
  background-color: #f5f6f9 !important;
  border-radius: 15px !important;
}

.card-container {
  width: 50%;
}

.card-detail {
  width: 70%;
}

.margin-auto {
  margin: auto;
}

.text-align-center {
  text-align: center;
}

.card-comment {
  width: 360px;
  padding: 5px 10px;
}

.card-item-gap {
  gap: 10px;
}

.card-item-padding {
  padding: 5px;
}

@media (max-width: 767px) {
  .new-card {
    width: 100%;
  }

  .card-container {
    width: 100%;
  }

  .card-comment {
    width: auto;
    padding-left: 0;
  }
}
</style>
